export const menuItems = [
  {link: "https://fpvfinder.lucafpv.com", label: "FPVfinder"},
  // {link: "/offerte-e-coupon", label: "Offerte"},
  {link: "/problemi-comuni-droni-fpv", label: "Problemi Comuni"},
  {link: "/articoli", label: "Blog"},
  {link: "/contattami", label: "Contattami"},
]